// @ts-nocheck
import constants from "@store/constants";
import { getBlogCategoryArticles, GetBlogCategoryArticlesApiParameter } from "@store/Framework/Services/BlogService";
import { BlogCategoryArticlesCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

type HandlerType = ApiHandler<GetBlogCategoryArticlesApiParameter, BlogCategoryArticlesCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter, type: constants.blog.getDataViewType.categoryArticles } as any; // 'type' is neccessary to differentiate dataView (cache) keys
};

export const DispatchBeginLoadBlogCategoryArticles: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBlogCategoryArticles(props.apiParameter);
};

export const DispatchCompleteLoadBlogCategoryArticles: HandlerType = props => {
    const state = props.getState();
    const { pages, pagination } = props.apiResult;

    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: {
            pages,
            pagination: pagination as any,
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadBlogCategoryArticles,
    RequestDataFromApi,
    DispatchCompleteLoadBlogCategoryArticles,
];

const loadBlogCategoryArticles = createHandlerChainRunner(chain, "LoadBlogCategoryArticles");
export default loadBlogCategoryArticles;
